import client from "./client";
import { menu } from "./menu";

export default {
  login(body) {
    let request = client.post("User/Login", body);
    request.then((response) => {
      let data = response.data;

      localStorage.setItem("token", data.token);
      localStorage.setItem("userData", this.parseJwt(data.token));
    });
    return request;
  },

  parseJwt(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return jsonPayload;
  },
  getUserPayload() {
    return JSON.parse(localStorage.getItem("userData"));
  },
  get(params) {
    let query = "?";
    Object.keys(params).forEach((k) => {
      query += k + "=" + params[k] + "&";
    });
    return client.get(`user/` + query);
  },
  create(body) {
    return client.post(`user/`, body);
  },
  edit(body) {
    return client.put(`user/`, body);
  },
  delete(id) {
    return client.delete(`user/` + id);
  },
};



// WEBPACK FOOTER //
// ./src/apiServices/userService.js